import { parseISO, format, sub } from 'date-fns';
import { isValidDate } from './helpers';
import * as dateFnLocale from 'date-fns/locale/index.js';

export function parseDate(date: Date | string): Date {
    if (isValidDate(date)) {
        return date;
    } else {
        return parseISO(date);
    }
}


export function getDatefnsLocale(locale: string) {
    const localeCamelCase = convertLanguageCodeToCamelCase(locale);
    if (dateFnLocale[localeCamelCase]) {
        return dateFnLocale[localeCamelCase];
    }
    if (dateFnLocale[locale.split('-')[0]]) {
        return dateFnLocale[locale.split('-')[0]];
    }
    if (locale.split('-')[0] === 'en') {
        return dateFnLocale.enGB;
    }
    return dateFnLocale.enGB;
}

function convertLanguageCodeToCamelCase(locale: string) {
    const parts = locale.split('-');
    if (parts.length === 1) {
        return locale;
    }
    const localeCamelCase = parts[0] + parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
    return localeCamelCase;
}

export function formatDate(date: Date | string, dateFormat: string, locale: string): string {
    return format(parseDate(date), dateFormat, { locale: getDatefnsLocale(locale) });
}

export function getDateFromDuration(duration: string, from: Date = new Date()): Date {
    // Extract numeric value and unit
    const match = duration.match(/^(\d+)([a-zA-Z]+)$/);
    if (!match) {
      throw new Error(`Invalid duration format: ${duration}`);
    }

    const value = parseInt(match[1], 10);
    const unit = match[2];

    switch(unit) {
      case 'd':
        return sub(from, { days: value });
      case 'M':
        return sub(from, { months: value });
      case 'y':
        return sub(from, { years: value });
      case 'w':
        return sub(from, { weeks: value });
      case 'h':
        return sub(from, { hours: value });
      case 'm':
        return sub(from, { minutes: value });
      case 's':
        return sub(from, { seconds: value });
      default:
        throw new Error(`Unsupported duration unit: ${unit}`);
    }
  }
